import { Typography } from "@circle-react-uikit/Typography";

import { CheckIcon } from "./CheckIcon";

interface MappedFeatureProps {
  value: string;
}

export const MappedFeature = ({ value }: MappedFeatureProps) => (
  <div className="flex items-center">
    <CheckIcon />
    <Typography.BodyMd color="text-default">{value}</Typography.BodyMd>
  </div>
);
